import { useMemo } from 'react';
import {
  IMAGE_URL_BY_CLUSTER,
  THUMB_BACKGROUND_BY_CLUSTER,
  TITLE_COLOR_BY_CLUSTER,
  EVALUATION_BACKGROUND_COLOR_BY_CLUSTER,
  EVALUATION_BORDER_COLOR_BY_CLUSTER,
  DESC_COLOR_BY_CLUSTER,
  SECTION_TITLE_COLOR_BY_CLUSTER,
} from '../constants';
import TypesReferenceInfoItem from './Item';
import { TYPE_DATAS } from './constants';

const TypesReferenceInfo = ({ type, commentTop, factorCluster, displayName }) => {
  const typeData = TYPE_DATAS.filter((item) => item.typeName === type);

  const { imageUrl, bgColor, titleColor, thumbBgColor, borderColor, descColor, sectionTitleCorlor } = useMemo(
    () => ({
      imageUrl: IMAGE_URL_BY_CLUSTER[factorCluster],
      bgColor: EVALUATION_BACKGROUND_COLOR_BY_CLUSTER[factorCluster],
      thumbBgColor: THUMB_BACKGROUND_BY_CLUSTER[factorCluster],
      titleColor: TITLE_COLOR_BY_CLUSTER[factorCluster],
      borderColor: EVALUATION_BORDER_COLOR_BY_CLUSTER[factorCluster],
      descColor: DESC_COLOR_BY_CLUSTER[factorCluster],
      sectionTitleCorlor: SECTION_TITLE_COLOR_BY_CLUSTER[factorCluster],
    }),
    [factorCluster],
  );

  return (
    <div className="w-full h-auto flex flex-row">
      {typeData.map((item, index) => (
        <TypesReferenceInfoItem
          key={index}
          typeName={item.typeName}
          title={item.title}
          description={commentTop || item.description}
          isTablet
          badge={item.badge}
          tags={item.tags}
          bgColor={bgColor}
          thumbBgColor={thumbBgColor}
          titleColor={titleColor}
          imageUrl={imageUrl}
          displayName={displayName}
          borderColor={borderColor}
          descColor={descColor}
          sectionTitleCorlor={sectionTitleCorlor}
        />
      ))}
    </div>
  );
};

export default TypesReferenceInfo;
